import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PaginationDoc } from '../models/pagination-doc';

@Component({
  selector: 'app-pagination-document',
  templateUrl: './pagination-document.component.html',
  styleUrls: ['./pagination-document.component.css']
})
export class PaginationDocumentComponent {
  @Input() nPages: number;
  @Output() changePage: EventEmitter<PaginationDoc> = new EventEmitter<PaginationDoc>();
  paginationDoc: PaginationDoc;
  selectedPage: number = 1;

  constructor() { }

  ngOnInit() {
    this.paginationDoc = new PaginationDoc(this.nPages);
  }


  increment() {
    if ((this.paginationDoc.getCurrentPage() + 1) < (this.paginationDoc.getNPages())) {
      this.paginationDoc.incrementPage();
      this.selectedPage = this.paginationDoc.getCurrentPage() + 1;
      this.changePage.emit(this.paginationDoc);
    }
  }

  decrement() {
    if (this.paginationDoc.getCurrentPage() > 0) {
      this.paginationDoc.decrementPage();
      this.selectedPage = this.paginationDoc.getCurrentPage() + 1;
      this.changePage.emit(this.paginationDoc);
    }
  }

  setCurrentPage() {
    if(this.selectedPage > 0 && this.selectedPage <= this.nPages) {
      this.paginationDoc.setCurrentPage(this.selectedPage - 1);
      this.changePage.emit(this.paginationDoc);
    } else {
      this.selectedPage = this.paginationDoc.getCurrentPage() + 1;
    }
  }
}
